export const PageTemplate = {
  tag: 'main',
  flow: 'column',
  width: '100%',
  margin: '- auto',
  maxWidth: 'K_default',
  padding: 'D2 E B1',
  flex: 1,
  '@screenS': {
    padding: 'C1 C B1',
  },
  '@tabletS': {
    padding: 'C1 B',
  },
};